import { ArchiveState } from '@app-types/enums/archiving';

export const TYPE_ARCHIVE: { [key: string]: string } = {
  1: 'None',
  2: 'GedCons',
  3: 'Ftp',
};

export const ARCHIVE_STATE_LABEL: { [key: string]: string } = {
  [ArchiveState.Off]: 'archivingNotProvided',
  [ArchiveState.NotReadyToCheck]: 'awaitingArchive',
  [ArchiveState.ReadyToCheck]: 'awaitingArchive',
  [ArchiveState.Checking]: 'sentToArchive',
  [ArchiveState.Archiving]: 'sentToArchive',
  [ArchiveState.Archived]: 'archived',
  [ArchiveState.Error]: 'errorArchive',
  [ArchiveState.NotArchived]: 'errorArchive',
};
